import React from "react";
import { pendingDoctorLabel } from "../card/PendingPaymentCard";
import { formatCountdown, useCountdown } from "../../hooks/useCountdown";
import { PendingPayment } from "../../services/pendingPaymentService";
import { formatRupiah } from "../../utils/formatPrice";

interface Props {
  pending: PendingPayment | null;
  onContinue: () => void;
  onCancelAndNew: () => void;
  onClose: () => void;
  loading?: boolean;
}

// Muncul saat pasien ingin membuat konsultasi baru padahal masih ada pembayaran tertunda.
const PendingPaymentModal: React.FC<Props> = ({ pending, onContinue, onCancelAndNew, onClose, loading }) => {
  const remaining = useCountdown(pending?.remaining_seconds);

  if (!pending) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl p-5 w-full max-w-sm shadow-lg">
        <h2 className="text-lg font-semibold text-gray-800 mb-1">Pembayaran Belum Selesai</h2>
        <p className="text-sm text-gray-600 mb-3">
          Anda masih memiliki pesanan konsultasi yang belum dibayar. Lanjutkan pembayaran atau batalkan pesanan tersebut untuk membuat pesanan baru.
        </p>

        <div className="bg-gray-50 rounded-lg p-3 text-sm mb-4">
          <p className="font-medium text-gray-800">{pendingDoctorLabel(pending)}</p>
          <p className="text-gray-500">
            {formatRupiah(pending.total)}
            {pending.payment_method ? ` · ${pending.payment_method}` : ""}
          </p>
          {pending.remaining_seconds > 0 && (
            <p className="text-amber-600 text-xs mt-1">Sisa waktu bayar {formatCountdown(remaining)}</p>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <button
            onClick={onContinue}
            disabled={loading || !pending.payment_url}
            className="bg-teal-500 text-white rounded-lg py-2.5 text-sm font-semibold disabled:opacity-50"
          >
            Lanjutkan Bayar
          </button>
          <button
            onClick={onCancelAndNew}
            disabled={loading}
            className="border border-red-300 text-red-500 rounded-lg py-2.5 text-sm font-medium disabled:opacity-50"
          >
            {loading ? "Membatalkan..." : "Batalkan & Buat Pesanan Baru"}
          </button>
          <button onClick={onClose} disabled={loading} className="text-gray-500 text-sm py-1">
            Tutup
          </button>
        </div>
      </div>
    </div>
  );
};

export default PendingPaymentModal;
